import { h } from 'preact';
import { formatPrice } from '../utils/format-price';
const GiftboxProduct = ({ handle , product , state , setState , isDiy  })=>{
    const title = product.title || handle;
    const description = product.description || '';
    var _product_price;
    const price = (_product_price = product.price) !== null && _product_price !== void 0 ? _product_price : null;
    const isSelected = state.giftbox === handle;
    var _product_smallImage, _product_smallImage1;
    return h('label', {
        key: handle,
        className: 'giftbox-product'
    }, [
        h('input', {
            type: 'radio',
            name: 'giftbox',
            value: handle,
            checked: isSelected,
            onInput: ()=>setState({
                    giftbox: handle,
                    variant: '',
                    items: [],
                    isDiy
                })
        }),
        h('div', {
            className: 'giftbox-product__content'
        }, [
            h('div', {
                className: 'giftbox-product__image'
            }, [
                ((_product_smallImage = product.smallImage) !== null && _product_smallImage !== void 0 ? _product_smallImage : product.featuredImage) ? h('img', {
                    src: (_product_smallImage1 = product.smallImage) !== null && _product_smallImage1 !== void 0 ? _product_smallImage1 : product.featuredImage,
                    alt: product.featuredImageAlt || title || handle,
                    width: 60,
                    height: 64,
                    decoding: 'async'
                }) : null
            ]),
            h('div', {
                className: 'giftbox-product__details-container'
            }, [
                h('div', {
                    className: 'giftbox-product__details'
                }, [
                    h('div', {
                        className: 'giftbox-product__title'
                    }, title),
                    h('div', {
                        className: 'giftbox-product__price'
                    }, formatPrice(price))
                ]),
                h('div', {
                    className: 'giftbox-product__description'
                }, description)
            ])
        ])
    ]);
};
export { GiftboxProduct };
